module.exports = __webpack_public_path__ + "static/media/sweet_onion.de6e08fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/toppings/sweet_onion.jpg
// module id = 137
// module chunks = 0